/**
 * "Audit log" — Dashboard section (ADR-0074).
 * Reconciled from apps/web audit-log feature (route /audit): an append-only,
 * tamper-evident, tenant-scoped record with a 400-day retention (ADR-0113).
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_AUDIT_PAGE: DocPageContent = {
  slug: 'dashboard/audit',
  titleKey: 'docs.dashboard.audit.title',
  descriptionKey: 'docs.dashboard.audit.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.audit.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'recorded',
      textKey: 'docs.dashboard.audit.recorded.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.audit.recorded.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.audit.recorded.item.override',
        'docs.dashboard.audit.recorded.item.transcript',
        'docs.dashboard.audit.recorded.item.promote',
        'docs.dashboard.audit.recorded.item.apikey',
      ],
    },

    { kind: 'heading', level: 2, id: 'entry', textKey: 'docs.dashboard.audit.entry.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.audit.entry.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.audit.entry.item.actor',
        'docs.dashboard.audit.entry.item.diff',
        'docs.dashboard.audit.entry.item.metadata',
      ],
    },

    { kind: 'heading', level: 2, id: 'filter', textKey: 'docs.dashboard.audit.filter.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.audit.filter.body' },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.audit.retention.title',
      textKey: 'docs.dashboard.audit.retention.body',
      links: {
        compliance: {
          target: { docSlug: 'trust/compliance' },
          labelKey: 'docs.dashboard.audit.retention.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.audit.next.convlogs.title',
          textKey: 'docs.dashboard.audit.next.convlogs.text',
          to: { docSlug: 'dashboard/conversation-logs' },
        },
        {
          titleKey: 'docs.dashboard.audit.next.actAsUser.title',
          textKey: 'docs.dashboard.audit.next.actAsUser.text',
          to: { docSlug: 'guides/act-as-user' },
        },
      ],
    },
  ],
};
